import React from "react";
import moment from "moment-timezone";
import { Box } from "@mui/material";

import {
  HOURS_12_FORMAT_WITH_DATE,
  PAYPAL_CODE_TRANSACTION_STATUS,
} from "../../../../../../constants";
import {
  CURRENT_TIME_ZONE_ABBREVIATION,
  getTimeByAmericaChicagoTz,
} from "../../../../../../utils/moment";
import { IntlFormatUSD } from "../../../../../../utils";

import {
  ICharge,
  ICustomerDbTransactions,
  IDbChargesByAPIIds,
} from "../../../../../../api/charges/index.types";

import { CopyToClipboard } from "../../../../../../components/ui";
import { ReactComponent as PayPalIc } from "../../../../../../assets/icons/pay_pal_ic.svg";
import { ReactComponent as StripeIc } from "../../../../../../assets/icons/stripe_s_ic.svg";
import { ReactComponent as BitPayIC } from "../../../../../../assets/icons/bitbay.svg";
import bridger from "../../../../../../assets/icons/bridgerpay_logo.png";

import { TCharge } from "../../index";
import { StyledTdNoWrap } from "../../../../../../useGeneralStyles";
import { STATUS_COLORS_OPACITY } from "../../../../../../constants";

interface IProps {
  chargesToRender: string[];
  apiDataCharges: TCharge<ICharge>;
  dbTransactions: TCharge<ICustomerDbTransactions>;
  dbTransactionsByAPIIds: TCharge<IDbChargesByAPIIds>;
}
const TableBody: React.FC<IProps> = ({
  chargesToRender,
  apiDataCharges,
  dbTransactions,
  dbTransactionsByAPIIds,
}) => {
  return (
    <tbody>
      {chargesToRender.map((charge_id) => {
        const currentCharge = apiDataCharges[charge_id];
        const currentDbChargeRecord = dbTransactions[charge_id];
        if (!currentCharge) {
          return null;
        }
        return (
          <Box
            component="tr"
            key={currentCharge.id}
            data-test="transaction-row"
            sx={{
              ...(!!currentCharge?.amount_refunded && {
                backgroundColor: "#ffff0000",
                borderBottom: "1px solid #000",
                borderTop: "1px solid #000",
                "& td": {
                  backgroundColor: STATUS_COLORS_OPACITY.lightRed,
                },
              }),
              ...(!currentCharge?.amount_refunded &&
                !!currentDbChargeRecord && {
                  backgroundColor: STATUS_COLORS_OPACITY.lightGreen,
                }),
              ...((currentCharge?.stripe_failure_code ||
                currentCharge?.status === "failed" ||
                currentCharge?.status === "D" ||
                currentCharge?.status === "declined") && {
                backgroundColor: "#ffff0000",
                borderBottom: "1px solid #000",
                borderTop: "1px solid #000",
                "& td": {
                  backgroundColor: "#ffff003b !important",
                },
              }),
            }}
          >
            <Box component="td" textAlign="center">
              {apiDataCharges[charge_id]?.source === "stripe" && (
                <StripeIc style={{ width: "20px", display: "inline-block" }} />
              )}
              {apiDataCharges[charge_id]?.source === "paypal" && (
                <PayPalIc style={{ width: "20px", display: "inline-block" }} />
              )}
              {apiDataCharges[charge_id]?.source === "bitpay" && (
                <BitPayIC style={{ width: "30px", display: "inline-block" }} />
              )}
              {apiDataCharges[charge_id]?.source === "bridgerpay" && (
                <img src={bridger} alt="bridgerpay_logo" style={{ width: "50px" }} />
              )}
            </Box>
            <td>
              <p style={{ whiteSpace: "pre" }}>
                {getTimeByAmericaChicagoTz(currentCharge?.date * 1000, true)} CT
              </p>
              <p style={{ whiteSpace: "pre" }}>
                {moment(currentCharge?.date * 1000).format(HOURS_12_FORMAT_WITH_DATE)}{" "}
                {CURRENT_TIME_ZONE_ABBREVIATION}
              </p>
            </td>
            <StyledTdNoWrap>
              {currentCharge?.amount_refunded
                ? `- ${IntlFormatUSD(currentCharge?.amount_refunded)}`
                : IntlFormatUSD(currentCharge?.amount)}
              {currentCharge?.transactionCurrency && (
                <p>
                  {currentCharge?.transactionCurrency}:{currentCharge.displayAmountPaid}
                </p>
              )}
            </StyledTdNoWrap>
            <td>
              {currentDbChargeRecord?.reset && (
                <p style={{ margin: 0 }}>
                  {currentDbChargeRecord.free_reset ? "Free" : "Paid"}
                  {currentDbChargeRecord?.reset && " reset"}
                </p>
              )}

              <p style={{ margin: 0 }}>{currentCharge?.object}</p>
            </td>
            <td>{currentCharge?.cardSource?.name || "n/a"}</td>
            <td>{currentCharge?.cardSource?.last4 || "n/a"}</td>
            <td>{currentCharge?.stripe_failure_code}</td>
            <td>{currentCharge?.outcome?.reason}</td>
            <td>
              {/* @ts-ignore */}
              {PAYPAL_CODE_TRANSACTION_STATUS[currentCharge.status]}
              {currentCharge.outcome?.seller_message} {currentCharge.stripe_failure_message}
            </td>
            <td>{currentDbChargeRecord?.discount_code?.code}</td>
            <td>
              <CopyToClipboard value={currentCharge.id} />
            </td>
            <td>{currentDbChargeRecord?.ip || ""}</td>
            <td>
              {dbTransactionsByAPIIds[charge_id] ? (
                <span style={{ color: "green" }}>✔</span>
              ) : (
                <span style={{ color: "red" }}>✘</span>
              )}
            </td>
          </Box>
        );
      })}
    </tbody>
  );
};
export default TableBody;
